<h2 class="font-weight-normal default-dialog-header" mat-dialog-title>
	<span fxFlex>{{ data.title }}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content font-size-12">
	<div
		*ngIf="data.updateField == UPDATE_TYPE.CARRIER"
		class="m-t-1"
		fxFlex
		fxLayoutAlign="center center"
	>
		<app-carrier-search-popover
			(setCarrier)="setCarrier($event)"
			[showCloseIcon]="true"
			[useAutoComplete]="true"
			[usePopover]="false"
			customFormFieldClass="custom-form-field"
			fxFlexFill
		>
		</app-carrier-search-popover>
	</div>

	<div
		*ngIf="data.updateField == UPDATE_TYPE.CUSTOMER"
		class="m-t-1"
		fxFlex
		fxLayoutAlign="center center"
	>
		<app-customer-popover (setCustomer)="setCustomer($event)" fxFlex></app-customer-popover>
	</div>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end">
		<button
			(click)="update()"
			*ngIf="!isRequestInProgress"
			[disabled]="disableUpdate()"
			color="primary"
			mat-raised-button
		>
			Update
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
